import { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { useAuth } from "../../Contexts/AuthContext"
import supabase from "../../utils/subabaseClient"

export default function useData(group_id) {
  const { user } = useAuth()

  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(false)

  const fetchExpenseGroup = async () => {
    setLoading(true)
    const { data } = await supabase
      .from("expense_groups")
      .select("*")
      .eq("id", group_id)
      .single()

    if (data) {
      setLoading(false)
      setIsAdmin(data.created_by === user?.id)
    }
  }

  const deleteExpenseGroup = async () => {
    setLoading(true)
    const { error } = await supabase
      .from("expense_groups")
      .delete()
      .eq("id", group_id)

    if (error) {
      toast.error(error.message)
    } else {
      toast.success("Expense group deleted successfully!")
    }
    setLoading(false)
  }

  useEffect(() => {

    if (!user) return
    if (!group_id) return

    fetchExpenseGroup()
  }, [group_id])

  return { isAdmin, deleteExpenseGroup, loading }
}
